{
	"title": "Без подключения",
	"leadAnonymous": "Похоже, у тебя нет интернета. Проверь Wi-Fi или мобильную сеть и попробуй ещё раз.",
	"leadAuth": "{name}, попробуй проверить Wi-Fi. Часть данных можно открыть из кэша.",
	"lastSync": "Последний sync",
	"noSync": "Нет данных о синхронизации",
	"retry": "Попробовать снова",
	"checking": "Проверяем подключение…",
	"openCached": "Открыть кэшированные",
	"restored": "Связь восстановлена",
	"restoredAuto": "Загрузить страницу заново",
	"limits": {
		"works": "Что работает офлайн",
		"fails": "Что недоступно",
		"notes": "Прочитанные конспекты",
		"flashcards": "Сохранённые карточки",
		"recordings": "Журнал записей лекций",
		"ai": "AI-генерация (репетитор, конспекты)",
		"search": "Поиск по всем материалам",
		"billing": "Биллинг"
	},
	"cached": {
		"available": "Доступно из кэша",
		"materials": "{count, plural, one {# материал} few {# материала} other {# материалов}}",
		"notes": "{count, plural, one {# конспект} few {# конспекта} other {# конспектов}}",
		"flashcards": "{count, plural, one {# карточка} few {# карточки} other {# карточек}}",
		"tutorChats": "{count, plural, one {# чат} few {# чата} other {# чатов}} с репетитором"
	},
	"banner": {
		"message": "Без сети — изменения сохранятся локально",
		"dismiss": "Закрыть"
	},
	"continueOnline": "Продолжить"
}
